import { useMutation } from "react-query";

import { dropdownValuesService } from "services";

type UseAgentsByCompanyIdQueryProps = {
	options?: any;
};
type MutationVariablesProps = {
	company_id: string;
	show_inactive: boolean;
	pattern: string;
	page_index: number;
	page_size: number;
};

const useAgentsByCompanyIdQuery = ({
	options,
}: UseAgentsByCompanyIdQueryProps = {}) =>
	useMutation(
		(variables: MutationVariablesProps) =>
			dropdownValuesService.getCompanyUsers(variables),
		{
			...options,
		},
	);

export default useAgentsByCompanyIdQuery;
